module.exports = __webpack_public_path__ + "static/media/DoctorPic.c64ce624.png";